import { ReactNode, createContext, useContext } from "react";
import {
  useThemePreference,
  type ThemePreference,
} from "@/contexts/useThemePreference";

const ThemeContext = createContext<ThemePreference | undefined>(undefined);

export function ThemeProvider({ children }: { children: ReactNode }) {
  const value = useThemePreference();

  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
}

export function useTheme(): ThemePreference {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
}
